import { IconPlus, IconUsersAlt } from '@maia/icons';
import { ButtonLink, PageHeader } from '@maia/ui';
import { createFileRoute } from '@tanstack/react-router';
import { getCustomersOptions } from '../../../features/customer/customers/queryOptions';
import { CustomersTable } from '../../../features/customer/customers/table';
import { mapInitialFilters } from '../../../utils/filter/utils';
import { validateSearch } from '../../../utils/pagination';

export const Route = createFileRoute('/_authenticated/customers/')({
  component: Page,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps: search }) =>
    queryClient.ensureQueryData(getCustomersOptions(mapInitialFilters(search))),
  validateSearch: validateSearch,
});

export function Page() {
  const data = Route.useLoaderData();
  return (
    <div className="layout-simple">
      <PageHeader
        className="area-page-header"
        icon={IconUsersAlt}
        title="Klanten"
        actions={
          <ButtonLink
            intent="cta"
            size="default"
            iconLeft={IconPlus}
            to="/customers/new"
          >
            Nieuwe klant
          </ButtonLink>
        }
      />
      <div className="area-page-content content-grid">
        <div className="col-span-full flex items-center justify-between">
          <CustomersTable customers={data} />
        </div>
      </div>
    </div>
  );
}
